import React from 'react';
import ReactDOM from 'react-dom';

import ProfileMenu from 'components/ProfileMenu';


export default function initProfileMenu(selector) {
    const elem = document.querySelector(selector);
    if (!elem) {
        return;
    }
    ReactDOM.render(
        <ProfileMenu
            user={DJ_CONST.user}
            languages={DJ_CONST.languages}
            languageCode={DJ_CONST.languageCode}
            languageNeutralURL={DJ_CONST.languageNeutralURL}
        />,
        elem);
}



// WEBPACK FOOTER //
// ./src/widgets/ProfileMenu.js